import { useMutation, gql } from '@apollo/client';
import {
  DeletarOfertaMutation,
  DeletarOfertaMutationVariables,
} from './__generated__/DeletarOfertaMutation';

const DELETAR_OFERTA_MUTATION = gql`
  mutation DeletarOfertaMutation($id_oferta: Int!) {
    deletarOferta(id_oferta: $id_oferta) {
      id_oferta
    }
  }
`;

const useDeletarOfertaMutation = () => {
  return useMutation<DeletarOfertaMutation, DeletarOfertaMutationVariables>(
    DELETAR_OFERTA_MUTATION
  );
};

export { useDeletarOfertaMutation };
